module.exports = __webpack_public_path__ + "assets/1e72daae95e957c7e9ede8daa10bc60e.mp3";